import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"
import apiUrl from "../apiUrl";
import { learningMapFormats } from "@/utils/constants/learningMapFormats.js";
import { assetTypes } from "@/utils/constants/assetTypes.js";
import { subjects } from "@/utils/constants/subjects.js";
import { languages } from "@/utils/constants/languages.js";
import { userDefaults } from "@/utils/constants/userDefaults.js";
import { is_touch_device } from "@/utils/isTouchDevice.js";

const env = process.env.NODE_ENV;

const state = {
    env: env,
    appUrl: apiUrl,
    filesUrl: 'upload',
    // defaultThumbnail: '/img/no-thumb.png',
    defaultThumbnail: '/img/zip.png',
    subjects: subjects,
    languages: languages,
    assetTypes: assetTypes,
    globalSearchAssetTypes: ['any'],
    globalSearchPublished: 'any',
    hcData: {},
    types: Object.keys(assetTypes).map(k => ({ value: k, name: assetTypes[k], count: 0 })),
    typeFilters             : Object.keys(assetTypes).reduce((filters, k) => {filters[k] = false; return filters}, {}),
    searchQuery: "",
    AppActiveUser           : userDefaults,
    bodyOverlay             : false,
    isVerticalNavMenuActive : true,
    is_touch_device         : is_touch_device(),
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : navbarSearchAndPinList,
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    scrollY                 : 0,
    starredPages            : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,
    isLoading: true,
    user: {role: {name: "guest"}},
    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
    supportWebp: false,
    learningMapFormats: learningMapFormats,
    resumableUploadChunkSize: 1024 * 1024 * 10
}

export default state
